import React, { Component } from 'react';

class WistiaPlayer extends Component {
  constructor(props) {
    super(props);
    const { hashedId, ...embedOptions } = { ...this.props }
    window._wq = window._wq || [];
    window._wq.push({
      id: hashedId,
      options: embedOptions,
      onHasData: (video) => {
        this.handle = video;
      }
    });
  }

  render() {
    return (
      <div className={`wistia_embed wistia_async_${this.props.hashedId} videoFoam=true`}style={{height: '100%', width: '100%'}}>&nbsp;</div>
    )
  }

  componentDidMount() {
    if (!document.getElementById("wistia_script")) {
      var wistiaScript = document.createElement("script");
      wistiaScript.id = "wistia_script"
      wistiaScript.type = "text/javascript"
      wistiaScript.src = "https://fast.wistia.com/assets/external/E-v1.js"
      wistiaScript.async = true
      document.body.appendChild(wistiaScript);
    }

  }

  componentWillUnmount() {
    this.handle && this.handle.remove();
  }
}

export default WistiaPlayer;
